export default {"src":"/_next/static/media/Microphone.0b027f57.svg","height":102,"width":102,"blurWidth":0,"blurHeight":0};